import React, { useContext, useEffect, useRef, useState } from "react";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { STAGE_ENUM } from "../../interface";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
    // logInfoAtom,
    modalObjAtom,
    openPaymentInfoAtom,
    rodinGenPipeline,
    rodinHistoryStatus,
    rodinModalLoadingAtom,
    rodinUploadedImages,
    subscriptionsInfoAtom,
    taskDetailAtom,
    showSubscribeAtom,
    setGenerateAtom,
    balanceAtom,
    imageWorkflowsAtom,
    selectedImageIndexAtom,
    checkImgConfirmAtom,
    checkDownloadAtom,
    // faceCheckListAtom
    // userPermissionAtom
} from "../../../../../store";
import { useTips } from "../../../../../common/GlobalTips";
import { trackEvent } from '../../../../../utils/trackEvent'
import { fetchSettings, startFakeProgressBar, doneFakeProgressBar } from "../../utils";
import {
    getTaskDetail,
    rodinConfirm,
    rodinHistory,
    rodinTexture,
    rodinUpdate,
    // rodinFaceEnhance
} from "../../../../../utils/net";
import style from "./material.module.css";
import { LockTip } from "../lockTip";
import { History } from "../history";
import { XscrollEasy } from "../../../../widgets/XscrollEasy";
import { ChangeConfirmTip } from "../changeConfirmTip";
import { WaitingProgress } from "../progressBar";
import * as Sentry from "@sentry/react";
import { ErrorPage } from "../../../../ErrorPage";
import { getCurrentUserTotalRedoCount } from "../../utils";
// import { RedoTips } from "../../../../newRodin/components/ShakeTips";
import { driver } from 'driver.js';
import { useRefreshInfo, useWebSocket } from '../../../../../utils/hooks';
import { Annotation } from '../Annotation'
import { useTranslation } from "react-i18next";
import { LuPlus } from "react-icons/lu";
import { PermissionContext } from "../../../../../utils/context";
import Restricted from "../../../../../utils/restricted";
import { use } from "i18next";
import ReactGA from "react-ga4";

const MaterialGeneration = ({ bodyRef, isMtlGeneratingRef, geomWrapperRef, packWrapperRef }) => {
    const { t } = useTranslation();
    const balance = useRecoilValue(balanceAtom);
    const [stage, setStage] = useState(STAGE_ENUM.DONE)
    const [isQueued, setIsQueued] = useState(false)
    const [defaultImageURLs, setDefaultImageURLs] = useRecoilState(rodinUploadedImages);
    const [selectedImageIndex, setSelectedImageIndex] = useRecoilState(selectedImageIndexAtom);
    const [checkImgConfirm, setCheckImgConfirm] = useRecoilState(checkImgConfirmAtom);
    const [checkDownload, setCheckDownload] = useRecoilState(checkDownloadAtom);
    const [userImage, setUserImage] = useState(null);
    const [userImageFileName, setUserImageFileName] = useState(null);
    const [inputText, setInputText] = useState('');
    const [generatePercentage, setGeneratePercentage] = useState(0)
    // const [openFaceCheck, setOpenFaceCheck] = useState(false)
    // const [faceCheckList, setFaceCheckList] = useState([])
    // const [faceFlag,setFaceFlag]=useState(false)
    // const faceEnablePage = useRef(null)
    // const [faceFlag, setFaceFlag] = useState(false)
    const [genPipeline, setGenPipeline] = useRecoilState(rodinGenPipeline);
    const setRodinModalLoading = useSetRecoilState(rodinModalLoadingAtom)
    const [historyStatus, setHistoryStatus] = useRecoilState(rodinHistoryStatus)
    const [currentDiesplyMaterial, setCurrentDiesplyMaterial] = useState(null)
    const [currentBaseConfig, setCurrentBaseConfig] = useState(false)
    const tip = useTips();
    const [imageWorkflows, setImageWorkflows] = useRecoilState(imageWorkflowsAtom);
    const [showSubTips, setShowSubTips] = useState(false);
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
    const isImgGenerateState = imageWorkflows[selectedImageIndex]?.status === STAGE_ENUM.GENERATE
    isMtlGeneratingRef.current = (stage === STAGE_ENUM.GENERATE)
    const isLocked = stage === STAGE_ENUM.LOCKED
    const isDone = stage === STAGE_ENUM.DONE
    const isGenerating = stage === STAGE_ENUM.GENERATING
    const isConfirmed = genPipeline.mtlConfirmed.status
    const geoPrompt = genPipeline.geoConfirmed.data
    const [currentVersion, setCurrentVersion] = useState('latest')
    const currentViewingHistory = useRef(null)
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const Fallback = <ErrorPage />;
    const [confirmBtnInfo, setComfirmBtnInfo] = useState(t('BUTTON_SMALL_MATERIAL_GENERATE'))
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const [modalObj, setModalObj] = useRecoilState(modalObjAtom);
    const taskDetail = useRecoilValue(taskDetailAtom);
    const { isAllowedTo, isCreatorOrAbove } = useContext(PermissionContext);
    const { refreshInfo } = useRefreshInfo()
    // const logInfo = useRecoilValue(logInfoAtom);
    // const groupInfo = useRecoilValue(groupInfoAtom);
    const [sliderValue, setSliderValue] = useState({
        temperature: {
            initialValue: 7.0,
            currentValue: 7.0
        },
        reference: {
            initialValue: 0.8,
            currentValue: 0.8
        },
        keepSeed: false
    });

    const [showRedoTemp, setShowRedoTemp] = useState(false)
    const [showGenerateTemp, setShowGenerateTemp] = useState(false)
    const { connect, query, disconnect, setReconnectAttempts, onMessage } = useWebSocket('/scheduler_socket');
    const setKeepRodinBoard = useSetRecoilState(setGenerateAtom)
    const mtlRef = useRef(null);
    const queuedIntervalRef = useRef(null);
    const taskTimeRef = useRef(null)
    const taskTimeValueRef = useRef(0)

    useEffect(() => {
        if (checkImgConfirm) {
            handleConfirm()
        }
    }, [checkImgConfirm])

    useEffect(() => {
        if (geomWrapperRef.current && packWrapperRef.current && bodyRef.current) {
            const totalHeight = bodyRef.current.offsetHeight
            const geomHeight = geomWrapperRef.current.offsetHeight
            const packHeight = packWrapperRef.current.offsetHeight

            // mtlRef.current.style.maxHeight = `${totalHeight - geomHeight - packHeight - 40}px`
        }
    }, [geomWrapperRef, packWrapperRef, bodyRef])

    const restoreStateDone = async () => {
        setStage(STAGE_ENUM.DONE)
        const chosenSettings = genPipeline?.taskInfo?.restore?.data?.material?.settings
        if (chosenSettings !== undefined) {
            const settingsData = await fetchSettings({ settings: chosenSettings });
            setInputText(settingsData.prompt)
        }
    }

    const restoreStateGenerate = async (selectedImage) => {
        setStage(STAGE_ENUM.GENERATE)
        setInputText(geoPrompt)
        const isViewOnly = genPipeline?.taskInfo?.restore?.data?.viewOnly
        if (isViewOnly) setStage(STAGE_ENUM.DONE)

        const processImageWorkflows = async () => {
            const newImageWorkflows = await Promise.all(defaultImageURLs.map(async (image, index) => {
                const fileName = image.fileName;
                const history = genPipeline.taskInfo?.restore?.data?.material?.history;
                // console.log('filename:', fileName);
                // console.log('history:', history);
                // console.log(' genPipeline.taskInfo:', genPipeline.taskInfo);
                if (fileName && genPipeline.taskInfo?.restore?.status && history) {
                    let versions = 0
                    let historySetting = false
                    let imageStage = STAGE_ENUM.GENERATE
                    if (history[fileName]) {
                        versions = Object.keys(history[fileName]).length;
                        historySetting = await fetchSettings({ settings: history[fileName][`v${versions}`].settings });
                        imageStage = STAGE_ENUM.GENERATED
                    }

                    if (index === selectedImage && historySetting) {
                        let chosenHistory = JSON.parse(JSON.stringify(history[fileName][`v${versions}`]));
                        chosenHistory.settings = historySetting;
                        chosenHistory.version = `v${versions}`
                        chosenHistory.ref_image = fileName
                        setCurrentBaseConfig(chosenHistory)
                        setInputText(historySetting.prompt)
                    } else {
                        console.error("Unable to find history setting for image, should not happen: ", fileName);
                    }

                    return {
                        redoCounter: getCurrentUserTotalRedoCount(subscriptionsInfo, "MTL", isAllowedTo('billing.feature')) - versions + 1,
                        status: imageStage,
                        prompt: historySetting.prompt ? historySetting.prompt : geoPrompt,
                        escore: historySetting.escore ? historySetting.escore : 7.0,
                        reference_scale: historySetting.reference_scale ? historySetting.reference_scale : 0.8
                    };
                }
                return {
                    redoCounter: getCurrentUserTotalRedoCount(subscriptionsInfo, "MTL", isAllowedTo('billing.feature')),
                    status: STAGE_ENUM.GENERATE,
                    prompt: geoPrompt,
                    escore: 7.0,
                    reference_scale: 0.8
                };
            }));

            setImageWorkflows(newImageWorkflows);
        };

        processImageWorkflows();

    }

    useEffect(() => {
        return () => {
            if (queuedIntervalRef.current) {
                clearInterval(queuedIntervalRef.current)
            }
        }
    }, [])

    const restoreImageSelection = async () => {
        const refImage = genPipeline.taskInfo?.restore?.data?.material?.refImage
        if (!refImage) return
        const selectedImage = defaultImageURLs.findIndex(image => image.fileName === refImage)
        setSelectedImageIndex(selectedImage)
        return selectedImage
    }

    // const faceEnhance = async (index, file) => {
    //     try {
    //         if(index === 0){
    //             return;
    //         }
    //         const formdata = new FormData()
    //         formdata.append('file', file)
    //         if(file){
    //             const faceEnhance = await rodinFaceEnhance(formdata)
    //             if (faceEnhance && faceEnhance.data) {
    //                 const newObj = {
    //                     id: index,
    //                     faceAllow: faceEnhance.data.allow_enhance,
    //                     defaultFace: faceEnhance.data.default_enhance,
    //                     enable: faceEnhance.data.default_enhance
    //                 }
    //                 setFaceCheckList((old) => [...old, newObj])
    //             } else {
    //                 const newObj = {
    //                     id: index,
    //                     faceAllow: false,
    //                     defaultFace: false,
    //                     enable: false
    //                 }
    //                 setFaceCheckList((old) => [...old, newObj])
    //             }
    //         }else{
    //             const newObj = {
    //                 id: index,
    //                 faceAllow: false,
    //                 defaultFace: false,
    //                 enable: false
    //             }
    //             setFaceCheckList((old) => [...old, newObj])
    //         }
            
    //     } catch (error) {
    //         Sentry.captureException(error)
    //         const newObj = {
    //             id: index,
    //             faceAllow: false,
    //             defaultFace: false,
    //             enable: false
    //         }
    //         setFaceCheckList((old) => [...old, newObj])
    //     }
    // }


    // useEffect(() => {
    //     if (defaultImageURLs.length > 0) {
    //         if (faceCheckList.length === 0) {
    //             if (taskDetail?.settings?.allow_face_enhance) {
    //                 const newObj = {
    //                     id: 0,
    //                     faceAllow: taskDetail.settings.allow_face_enhance,
    //                     defaultFace: taskDetail.settings.default_face_enhance,
    //                     enable: taskDetail.settings.default_face_enhance
    //                 }
    //                 setFaceCheckList((old) => [...old, newObj])
    //             } else {
    //                 const newObj = {
    //                     id: 0,
    //                     faceAllow: false,
    //                     defaultFace: taskDetail.settings.default_face_enhance,
    //                     enable: false
    //                 }
    //                 setFaceCheckList((old) => [...old, newObj])
    //             }
    //             // defaultImageURLs.map(async (item, index) => {
    //             //     if (index !== 0 && item?.file) {
    //             //         faceEnhance(index, item.file)
    //             //     }
    //             // })
    //         } else if (defaultImageURLs.length - faceCheckList.length === 1 && defaultImageURLs[defaultImageURLs.length - 1]?.file) {
    //             faceEnhance(defaultImageURLs.length - 1, defaultImageURLs[defaultImageURLs.length - 1]?.file ? defaultImageURLs[defaultImageURLs.length - 1].file:false)
    //         }

    //     }
    // }, [defaultImageURLs])

    useEffect(() => {
        const hasGenerated = imageWorkflows.some(image => image.status === STAGE_ENUM.GENERATED || image.status === STAGE_ENUM.CHANGED || image.status === STAGE_ENUM.CHANGED_CONFIRM);
        try {
            if (genPipeline.geoConfirmed.status
                && genPipeline.mtlConfirmed.status) {
                restoreStateDone()
                restoreImageSelection()

            }

            if (genPipeline.geoConfirmed.status
                && !genPipeline.mtlConfirmed.status
                && !isGenerating
                && !hasGenerated) {
                const selectedImage = restoreImageSelection()
                // if(genPipeline?.geoLoaded?.status && selectedImageIndex!==0){
                //     faceEnhance(selectedImageIndex, defaultImageURLs[selectedImageIndex]?.file ? defaultImageURLs[selectedImageIndex].file:false)
                // }
                restoreStateGenerate(selectedImage)
                
            }

            if (!genPipeline.geoConfirmed.status) {
                setStage(STAGE_ENUM.LOCKED)
            }


        } catch (e) {
            Sentry.captureException(e)
            tip({
                type: 'error',
                presetText: 'ERROR',
                content: t('TIP_ERR_RODINMAT_RESTOR') + e,
            });
        }
    }, [genPipeline])

    // useEffect(() => {
    //     console.log(imageWorkflows, '---imageWorkflows');
    //     if (imageWorkflows[selectedImageIndex]) {
    //         setSliderValue(pre => {
    //             return {
    //                 temperature: {
    //                     ...pre.temperature,
    //                     currentValue: imageWorkflows[selectedImageIndex]?.escore ? imageWorkflows[selectedImageIndex].escore : 7.0,
    //                     initialValue: imageWorkflows[selectedImageIndex]?.escore ? imageWorkflows[selectedImageIndex].escore : 7.0
    //                 },
    //                 reference: {
    //                     ...pre.reference,
    //                     currentValue: imageWorkflows[selectedImageIndex]?.reference_scale ? imageWorkflows[selectedImageIndex].reference_scale : 0.8,
    //                     initialValue: imageWorkflows[selectedImageIndex]?.reference_scale ? imageWorkflows[selectedImageIndex].reference_scale : 0.8
    //                 }
    //             }
    //         })
    //     }
    // }, [imageWorkflows])

    useEffect(() => {
        if (genPipeline.mtlConfirmed.status) {
            setStage(STAGE_ENUM.DONE)
        }
    }, [genPipeline])

    const changePromptInImageWorkflows = (prompt, selectedImageIndex = selectedImageIndex, recordStatus = false) => {
        setImageWorkflows(imageWorkflows.map((workflow, index) => {
            if (index === selectedImageIndex) {
                if (workflow.status !== STAGE_ENUM.GENERATE && recordStatus) {
                    return { ...workflow, prompt: prompt, status: STAGE_ENUM.CHANGED };
                } else if (workflow.status === STAGE_ENUM.CHANGED) {
                    return { ...workflow, prompt: prompt, status: STAGE_ENUM.GENERATED };
                } else {
                    return { ...workflow, prompt: prompt };
                }
            }
            return workflow;
        }));
    }

    const handleInputTextChange = (event) => {
        setInputText(event.target.value);
        return changePromptInImageWorkflows(event.target.value, selectedImageIndex, true);
    };

    const hasHistory = () => {
        return !imageWorkflows.every(image => image.status === STAGE_ENUM.GENERATE);
    }

    const getRedoCounter = (index = selectedImageIndex) => {
        try {
            if (
                imageWorkflows.length
            ) {
                return imageWorkflows[index].redoCounter;
            }
            return -1;
        } catch (e) {
            console.error("Error getting redo counter: ", e)
            console.error("Index: ", index)
            console.error("Image Workflows: ", imageWorkflows)
            return -1;
        }
    }

    const handleSelectImage = async (index, newfile = false) => {
        if (index !== selectedImageIndex) {
            setCheckImgConfirm(false)
        }
        const uuid = genPipeline.taskInfo.data;
        if (stage !== STAGE_ENUM.GENERATING) {
            setSelectedImageIndex(index);
            // if(faceCheckList.filter(item=>item.id===index).length === 0 && index !== 0 && index !== currentDiesplyMaterial && defaultImageURLs[index]?.file){
            //     faceEnhance(index, defaultImageURLs[index].file ? defaultImageURLs[index].file:false)
            // }

            if (!imageWorkflows[index]) {
                return
            }
            if (imageWorkflows[index]?.prompt) {
                setInputText(imageWorkflows[index].prompt)
            } else {
                setInputText('')
            }
            // Avoid duplicate loading
            if (index === currentDiesplyMaterial) {
                return
            }
            if (userImageFileName && index >= defaultImageURLs.length && imageWorkflows[index].status === STAGE_ENUM.GENERATED) {
                loadLatestMtl(uuid, userImageFileName)
                setCurrentDiesplyMaterial(index)
            } else if (imageWorkflows[index].status === STAGE_ENUM.GENERATED) {
                loadLatestMtl(uuid, defaultImageURLs[index].fileName)
                setCurrentDiesplyMaterial(index)
            }
        }
    };

    const handleUserImageRemove = (event) => {
        event.stopPropagation();
        handleSelectImage(0);
        const updatedImageWorkflows = imageWorkflows.slice(0, imageWorkflows.length - 1);
        setImageWorkflows(updatedImageWorkflows);
        setUserImage(null);
        setUserImageFileName(null);
    }

    const handleUserUpload = () => {

        const file = event.target.files[0];
        if (!file) return
        const imageURL = URL.createObjectURL(file);
        // setUserImage(imageURL);
        const newUserImageIndex = defaultImageURLs.length;
        
        // Add new image
        const newDefaultImageURLs = [...defaultImageURLs, { fileName: false, data: imageURL, file: file }];

        setImageWorkflows([...imageWorkflows,
        {
            redoCounter: getCurrentUserTotalRedoCount(subscriptionsInfo, "MTL", isAllowedTo('billing.feature')),
            status: STAGE_ENUM.GENERATE,
            prompt: geoPrompt,
            escore: 7.0,
            reference_scale: 0.8
        }]);
        setInputText(geoPrompt);
        setDefaultImageURLs(newDefaultImageURLs);


        handleSelectImage(newUserImageIndex, file);
        event.target.value = '';
    };

    const handleRedo = async () => {
        try {
            if (getRedoCounter() === -1) {
                tip({
                    type: 'error',
                    presetText: 'ERROR',
                    content: t('TIP_ERR_RODINMAT_REDO_COUNTER'),
                });
            }
            if (getRedoCounter() <= 0 && getRedoCounter() !== -1) {
                tip({
                    type: 'primary',
                    content: t('TIP_PRIMARY_RODINMAT_MAX_REDO'),
                });
                return
            }


            const res = await handleGenerate("REDO")

            if (!res) {
                setStage(STAGE_ENUM.GENERATE)
                return
            }

            setImageWorkflows(imageWorkflows.map((workflow, index) => {
                if (index === selectedImageIndex) {
                    return { ...workflow, status: STAGE_ENUM.GENERATED, redoCounter: workflow.redoCounter - 1 };
                }
                return workflow;
            }));
        } catch (e) {
            tip({
                type: 'error',
                presetText: 'ERROR',
                content: t('TIP_ERR_RODINMAT_REDO') + e,
            });
            console.error("Redo failed: ", e)
            console.error("Selected Image Index: ", selectedImageIndex)
            console.error("Image Workflows: ", imageWorkflows)
        }
    };

    // const handlerStop = (e) => {
    //     e.stopPropagation()
    // }

    const driverGuide = (balance) => {
        setModalObj({ ...modalObj, state: false });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setOpenPaymentInfo({
            ...openPaymentInfo,
            state: true,
            group: taskDetail?.group,
            balance: balance,
            step: 1
        })

        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
        });
        const target = taskDetail?.group ? "#rechargeGroup #rechargePopup" : "#rechargeSelf #rechargePopup"
        driverObj.highlight({
            element: target,
            popover: {
                title: t('DRIVEROBJ_BALANCE_TITLE'),
                description: t('DRIVEROBJ_BALANCE_DESC'),
                popoverClass: "rechargedriver"
            }
        });
        if (document.querySelector(target)) {
            document.querySelector(target).addEventListener("click", () => {
                driverObj.destroy();
            });
        }
    }

    const handleGenerate = async (type) => {
        const currentStatus = stage
        try {
            if (taskTimeRef.current) {
                clearInterval(taskTimeRef.current)
            }
            taskTimeValueRef.current = 0
            // if (isAllowedTo('billing.feature')) {
            //     const isGroupLowBalance = taskDetail?.group && (balance.groupBalance / 10) < 3
            //     const isPersonalLowBalance = !taskDetail?.group && (balance.selfBalance / 10 + subscriptionsInfo.wallet_balance / 10) < 3
            //     if (isGroupLowBalance || isPersonalLowBalance) {
            //         driverGuide()
            //         return
            //     }
            // }
            const uuid = genPipeline.taskInfo.data;

            if (!inputText) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_PROMPT_EMPTY'),
                });
                return false
            }

            setStage(STAGE_ENUM.GENERATING)

            let imageFileName = ""
            let subKey = ''
            let jobid = ''
            // let face_enhance = false
            if (selectedImageIndex >= defaultImageURLs.length && !userImage) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_RODINGEO_NO_IMG_SELECT'),
                });
                return false
            } else if (defaultImageURLs[selectedImageIndex].fileName === false) {
                // if (faceCheckList.filter(item => item.id === selectedImageIndex).length > 0) {
                //     face_enhance = faceCheckList.filter(item => item.id === selectedImageIndex)[0].enable
                // }
                if (type === "GENERATE") {
                    const res = await rodinTexture({
                        uuid: uuid, prompt: inputText, image: defaultImageURLs[selectedImageIndex].file, escore: sliderValue.temperature.currentValue, reference_scale: sliderValue.reference.currentValue
                    });
                    trackEvent('Rodin - Material - Generate: Start', res, genPipeline?.taskInfo.data)
                    subKey = res?.data?.job?.subscription_key
                    jobid = res?.data?.job?.uuids[0]
                    if (res?.data?.error || !subKey) {
                        if (res?.data?.error === 'INSUFFICIENT_BALANCE') {
                            driverGuide()
                        } else {
                            tip({
                                type: 'error',
                                presetText: 'ERROR',
                                content: t('TIP_ERR_GEN_FAILED'),
                            });
                        }
                        return false
                    }
                    imageFileName = res?.data?.reference_filename
                    //setUserImageFileName(imageFileName)
                    const newDefaultImageURLs = [...defaultImageURLs];
                    newDefaultImageURLs[selectedImageIndex] = { ...newDefaultImageURLs[selectedImageIndex], fileName: imageFileName };
                    setDefaultImageURLs(newDefaultImageURLs);
                } else if (type === "REDO") {
                    imageFileName = defaultImageURLs[selectedImageIndex].fileName
                    const res = await rodinUpdate({
                        prompt: inputText, uuid, reference_image: imageFileName, escore: sliderValue.temperature.currentValue, seed: sliderValue.keepSeed ? -1 : 0, reference_scale: sliderValue.reference.currentValue
                    })
                    trackEvent('Rodin - Material - Redo: Start', res, genPipeline?.taskInfo.data)
                    subKey = res?.data?.job?.subscription_key
                    jobid = res?.data?.job?.uuids[0]
                    if (res?.data?.error || !subKey) {
                        setStage(STAGE_ENUM.GENERATE)
                        tip({
                            type: 'error',
                            presetText: 'ERROR',
                            content: t('TIP_ERR_GEN_FAILED'),
                        });
                        return false
                    }
                }
            } else {
                // if (faceCheckList.filter(item => item.id === selectedImageIndex).length > 0) {
                //     face_enhance = faceCheckList.filter(item => item.id === selectedImageIndex)[0].enable
                // }
                imageFileName = defaultImageURLs[selectedImageIndex].fileName
                let res = ''
                if (type === "GENERATE") {
                    res = await rodinTexture({
                        prompt: inputText, uuid, texture_reference_filename: imageFileName, escore: sliderValue.temperature.currentValue, reference_scale: sliderValue.reference.currentValue
                    })
                    trackEvent('Rodin - Material - Generate: Start', res, genPipeline?.taskInfo.data)
                    subKey = res?.data?.job?.subscription_key
                    jobid = res?.data?.job?.uuids[0]
                } else if (type === "REDO") {
                    res = await rodinUpdate({
                        prompt: inputText, uuid, reference_image: imageFileName, escore: sliderValue.temperature.currentValue, seed: sliderValue.keepSeed ? -1 : 0, reference_scale: sliderValue.reference.currentValue
                    })
                    trackEvent('Rodin - Material - Redo: Start', res, genPipeline?.taskInfo.data)
                    subKey = res?.data?.job?.subscription_key
                    jobid = res?.data?.job?.uuids[0]
                }
                if (res?.data?.error || !subKey) {
                    setStage(STAGE_ENUM.GENERATE)
                    tip({
                        type: 'error',
                        presetText: 'ERROR',
                        content: t('TIP_ERR_GEN_FAILED'),
                    });
                    return false
                }
            }
            // console.log(subKey, '----subKey---');
            let queued = 0
            let hasStartedQueued = false
            let hasStartedGenerating = false
            return new Promise((resolve) => {
                setKeepRodinBoard(true)
                connect(subKey, jobid)
                queuedIntervalRef.current = setInterval(() => {
                    query(jobid)
                }, 10000)
                taskTimeRef.current = setInterval(()=>{
                    taskTimeValueRef.current = taskTimeValueRef.current + 1
                },1000)
                setReconnectAttempts(0)
                onMessage('message', async (data, res) => {
                    if (res?.jobStatus === 'Queued') {
                        setIsQueued(true)
                        if (!hasStartedQueued) {
                            setGeneratePercentage(0)
                            const progressBarDelay = 50;
                            startFakeProgressBar(setGeneratePercentage, progressBarDelay, 10)
                            queued = res?.jobWaitingLength ? res.jobWaitingLength:0 + 1
                            hasStartedQueued = true
                        } else {
                            const progressBarDelay = 50;
                            startFakeProgressBar(setGeneratePercentage, progressBarDelay, -((res?.jobWaitingLength ? res.jobWaitingLength:0) * 10 - Number(queued) * 10))
                        }

                    }
                    if (res?.jobStatus === 'BackPressure') {
                        setGeneratePercentage(0)
                        setIsQueued(true)
                    }
                    if (res?.jobStatus === 'Running' && !hasStartedGenerating) {
                        // if (queuedIntervalRef.current) {
                        //     clearInterval(queuedIntervalRef.current)
                        // }
                        if (queued === 0) {
                            setGeneratePercentage(0)
                        } else {
                            doneFakeProgressBar(setGeneratePercentage, queued * 10)
                        }
                        setIsQueued(false)
                        hasStartedGenerating = true
                        const progressBarDelay = 85 + queued * 7
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay)
                    }
                    if (res?.jobStatus === 'Canceled') { 
                        trackEvent(`Rodin - Material - ${type === "GENERATE" ? 'Generate':'Redo'}: Canceled`, false, genPipeline?.taskInfo.data)
                        ReactGA.event(
                            {
                                category: 'hyper3d',
                                action: 'failed_material_generate',
                                label: 'pressure_tracking'
                            }
                        )
                        if (queuedIntervalRef.current) {
                            clearInterval(queuedIntervalRef.current)
                        }
                        if (taskTimeRef.current) {
                            clearInterval(taskTimeRef.current)
                        }
                        taskTimeValueRef.current = 0
                        setStage(STAGE_ENUM.GENERATED)
                        tip({
                            type: 'error',
                            content: t('TIP_ERR_KINDLY_ANEW')
                        })
                        resolve(false)
                        return
                    }
                    // Fetch preview images
                    if (res?.jobStatus === 'Succeeded') {
                        if (queuedIntervalRef.current) {
                            clearInterval(queuedIntervalRef.current)
                        }
                        if (!hasStartedGenerating) {
                            if (queued === 0) {
                                setGeneratePercentage(0)
                            } else {
                                doneFakeProgressBar(setGeneratePercentage, queued * 10)
                            }
                        }
                        trackEvent(`Rodin - Material - ${type === "GENERATE" ? 'Generate':'Redo'}: Succeeded`, { credits:0, executionTime:taskTimeValueRef.current }, genPipeline?.taskInfo.data)
                        setIsQueued(false)
                        doneFakeProgressBar(setGeneratePercentage, 100)
                        if (taskTimeRef.current) {
                            clearInterval(taskTimeRef.current)
                        }
                        setTimeout(async () => {
                            setKeepRodinBoard(false)
                            await loadLatestMtl(uuid, imageFileName);
                            setCurrentDiesplyMaterial(selectedImageIndex);
                            refreshInfo(taskDetail?.group ? 'group' : 'user');
                            setStage(STAGE_ENUM.GENERATED);
                            setGeneratePercentage(0)
                            taskTimeValueRef.current = 0
                            disconnect();
                            resolve(true); // 解决Promise
                        }, 1000);
                    }
                }, () => {
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'failed_material_generate',
                            label: 'pressure_tracking'
                        }
                    )
                    if (queuedIntervalRef.current) {
                        clearInterval(queuedIntervalRef.current)
                    }
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                    setStage(STAGE_ENUM.GENERATED)
                    tip({
                        type: 'error',
                        content: t('TIP_ERR_KINDLY_ANEW')
                    })
                    resolve(false)
                    return
                });
            });
        } catch (error) {
            trackEvent(`Rodin - Material - ${type === "GENERATE" ? 'Generate':'Redo'}: Failed`, false, genPipeline?.taskInfo?.data)
            setStage(currentStatus)
        }
    }

    useEffect(() => {
        if (stage === STAGE_ENUM.GENERATED) {
            setGeneratePercentage(0)
        }
    }, [stage])

    const getLatestVersion = async (uuid, imageFileName, resHistory) => {
        if (resHistory.data && resHistory.data[imageFileName]) {
            const versions = Object.keys(resHistory.data[imageFileName]);
            return versions.sort((a, b) => {
                const numA = parseInt(a.substring(1), 10);
                const numB = parseInt(b.substring(1), 10);
                return numB - numA;
            })[0]
        } else {
            console.error('Unable to find model_urls');
            return false
        }
    }

    const loadLatestMtl = async (uuid, imageFileName) => {
        const resHistory = await rodinHistory({ uuid });
        let baseConfig = ""
        getLatestVersion(uuid, imageFileName, resHistory).then(highestVersion => {
            if (!highestVersion) {
                return
            }
            // Reason for add version and ref_image: to fallback when preview history
            baseConfig = resHistory.data[imageFileName][highestVersion];
            baseConfig.version = highestVersion
            baseConfig.ref_image = imageFileName
            setCurrentBaseConfig(baseConfig)
            setRodinModalLoading(true)
            setGenPipeline(pre => {
                return {
                    ...pre,
                    mtlLoading: {
                        status: true,
                        data: baseConfig,
                        timestamp: Date.now()
                    }
                }
            });
        })
    }

    const getSelectedImageFileName = (selectedImageIndex = setSelectedImageIndex) => {
        if (selectedImageIndex < defaultImageURLs.length) {
            return defaultImageURLs[selectedImageIndex].fileName;
        } else if (userImageFileName) {
            return userImageFileName;
        } else {
            console.error('selectedImageIndex < defaultImageURLs.length', selectedImageIndex, defaultImageURLs);
        }
        return false;
    }

    const handleConfirm = async () => {
        try {
            if (taskTimeRef.current) {
                clearInterval(taskTimeRef.current)
            }
            taskTimeValueRef.current = 0
            const uuid = genPipeline.taskInfo.data;
            const imageFileName = getSelectedImageFileName(selectedImageIndex);
            const history = await rodinHistory({ uuid });
            let version

            if (currentVersion === "latest") {
                version = await getLatestVersion(uuid, imageFileName, history)
            } else {
                version = currentVersion
            }

            if (version === false) {
                tip({
                    type: 'error',
                    presetText: 'ERROR',
                    content: t('TIP_ERR_RODINMAT_NO_VERSION'),
                });
                console.error("No version to confirm")
                console.error("Version for Confirm: ", version)
                console.error("History: ", history)
                console.error("ImageFileName: ", imageFileName)
                console.error("UUID: ", uuid)
                return
            }

            setStage(STAGE_ENUM.GENERATING)

            const confirmParams = {
                uuid: uuid,
                version: version,
                reference_image: imageFileName
            }
            const res = await rodinConfirm(confirmParams);
            const subKey = res?.data?.job?.subscription_key
            const jobid = res?.data?.job?.uuids[0]

            if (res?.data?.error || !subKey) {
                setStage(STAGE_ENUM.GENERATE)
                tip({
                    type: 'error',
                    presetText: 'ERROR',
                    content: t('TIP_ERR_RODINMAT_CONFIRM'),
                });
                return
            }
            setKeepRodinBoard(true)
            connect(subKey, jobid)
            queuedIntervalRef.current = setInterval(() => {
                query(jobid)
            }, 10000)
            trackEvent(`Rodin - Material - Confirm: Start`, confirmParams, genPipeline?.taskInfo.data)
            taskTimeRef.current = setInterval(()=>{
                taskTimeValueRef.current = taskTimeValueRef.current + 1
            },1000)
            setReconnectAttempts(0)
            let queued = 0
            let hasStartedQueued = false
            let hasStartedGenerating = false
            onMessage('message', async (data, res) => {
                if (res?.jobStatus === 'Queued') {
                    setIsQueued(true)
                    if (!hasStartedQueued) {
                        setGeneratePercentage(0)
                        const progressBarDelay = 50;
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay, 10)
                        queued = res?.jobWaitingLength ? res.jobWaitingLength:0 + 1
                        hasStartedQueued = true
                    } else {
                        const progressBarDelay = 50;
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay, -((res?.jobWaitingLength ? res.jobWaitingLength:0) * 10 - Number(queued) * 10))
                    }

                }
                if (res?.jobStatus === 'BackPressure') {
                    setGeneratePercentage(0)
                    setIsQueued(true)
                }
                if (res?.jobStatus === 'Running' && !hasStartedGenerating) {
                    // if (queuedIntervalRef.current) {
                    //     clearInterval(queuedIntervalRef.current)
                    // }
                    if (queued === 0) {
                        setGeneratePercentage(0)
                    } else {
                        doneFakeProgressBar(setGeneratePercentage, queued * 10)
                    }
                    setIsQueued(false)
                    hasStartedGenerating = true
                    const progressBarDelay = 30 + queued * 2;
                    startFakeProgressBar(setGeneratePercentage, progressBarDelay)
                }
                // Fetch preview images
                if (res?.jobStatus === 'Canceled') { 
                    trackEvent(`Rodin - Material - Confirm: Canceled`, false, genPipeline?.taskInfo.data)
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'failed_material_confirm',
                            label: 'pressure_tracking'
                        }
                    )
                    if (queuedIntervalRef.current) {
                        clearInterval(queuedIntervalRef.current)
                    }
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                    setStage(STAGE_ENUM.GENERATED)
                    tip({
                        type: 'error',
                        content: t('TIP_ERR_KINDLY_ANEW')
                    })
                    disconnect()
                    return
                }
                if (res?.jobStatus === 'Succeeded') {
                    if (queuedIntervalRef.current) {
                        clearInterval(queuedIntervalRef.current)
                    }
                    if (!hasStartedGenerating) {
                        if (queued === 0) {
                            setGeneratePercentage(0)
                        } else {
                            doneFakeProgressBar(setGeneratePercentage, queued * 10)
                        }
                    }
                    trackEvent(`Rodin - Material - Confirm: Succeeded`, { credits:0, executionTime:taskTimeValueRef.current }, genPipeline?.taskInfo.data)
                    setIsQueued(false)
                    doneFakeProgressBar(setGeneratePercentage, 100)
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    setTimeout(async () => {
                        setKeepRodinBoard(false)
                        setStage(STAGE_ENUM.DONE)
                        setGeneratePercentage(0)
                        taskTimeValueRef.current = 0
                        setHistoryStatus({ ...historyStatus, showHistoryList: false })
                        setGenPipeline(pre => {
                            return {
                                ...pre,
                                mtlConfirmed: {
                                    status: true,
                                    data: null,
                                    timestamp: Date.now()
                                }
                            }
                        });
                        if (checkImgConfirm) {
                            setCheckImgConfirm(false)
                        }

                        disconnect();
                    }, 1000);
                }
            }, () => {
                ReactGA.event(
                    {
                        category: 'hyper3d',
                        action: 'failed_material_confirm',
                        label: 'pressure_tracking'
                    }
                )
                if (queuedIntervalRef.current) {
                    clearInterval(queuedIntervalRef.current)
                }
                if (taskTimeRef.current) {
                    clearInterval(taskTimeRef.current)
                }
                taskTimeValueRef.current = 0
                setStage(STAGE_ENUM.GENERATED)
                tip({
                    type: 'error',
                    content: t('TIP_ERR_KINDLY_ANEW')
                })
                disconnect()
                return
            });
        } catch (error) {
            trackEvent(`Rodin - Material - Confirm: Failed`, false, genPipeline?.taskInfo?.data)
            setStage(STAGE_ENUM.GENERATED)
        }
    }

    const handleConfirmOrGenerate = async (enforceConfirm = false) => {
        if (enforceConfirm) {
            await handleConfirm()
            return
        }

        if (stage === STAGE_ENUM.CHANGED_CONFIRM) {
            return
        }
        try {
            if (imageWorkflows[selectedImageIndex]?.status === STAGE_ENUM.GENERATE) {
                // if (faceCheckList.filter(item => item.id === selectedImageIndex)[0]?.faceAllow && !faceCheckList.filter(item => item.id === selectedImageIndex)[0]?.defaultFace && !faceCheckList.filter(item => item.id === selectedImageIndex)[0]?.enable) {
                //     setOpenFaceCheck(true)
                //     return;
                // }
                const res = await handleGenerate("GENERATE")
                if (!res) {
                    setStage(STAGE_ENUM.GENERATE)
                    return
                }
                setImageWorkflows(imageWorkflows.map((workflow, index) => {
                    if (index === selectedImageIndex) {
                        return { ...workflow, status: STAGE_ENUM.GENERATED };
                    }
                    return workflow;
                }));

            } else if (imageWorkflows[selectedImageIndex]?.status === STAGE_ENUM.CHANGED) {
                setStage(STAGE_ENUM.CHANGED_CONFIRM)
            } else {
                await handleConfirm()
            }
        } catch (error) {
            Sentry.captureException(error);
            console.error(error);
        }
    };

    const getCurrentImageURL = () => {
        try {
            if (selectedImageIndex < defaultImageURLs.length) {
                return defaultImageURLs[selectedImageIndex].data;
            }
            return userImage;
        } catch (e) {
            console.error("Error getting current image URL: ", e)
            console.error("Selected Image Index: ", selectedImageIndex)
            console.error("Default Image URLs: ", defaultImageURLs)
            return false;
        }
    };

    const loadHistory = async (baseConfig = false) => {
        try {
            if (!baseConfig) {
                baseConfig = historyStatus.selectedHistory ? historyStatus.selectedHistory : historyStatus.previewHistory
            }
            const settings = baseConfig.settings
            if (!settings) {
                throw Error('NO_HISTORY_SETTINGS');
            }
            let index = defaultImageURLs.findIndex(image => image.fileName === baseConfig.ref_image)
            if (index !== -1) {
                changePromptInImageWorkflows(settings.prompt, index);
            } else {
                const uuid = genPipeline.taskInfo.data;
                const taskRes = await getTaskDetail(uuid)
                const images = taskRes.data.rodin_generate_info.material_input_images
                const customImageURL = images[baseConfig.ref_image]
                setUserImage(customImageURL)
                setUserImageFileName(baseConfig.ref_image)
                index = defaultImageURLs.length
            }

            setInputText(settings?.prompt)
            setSelectedImageIndex(index)
            // Update redoCounter
            if (baseConfig.version_num) {
                const newImageWorkflows = [...imageWorkflows];
                newImageWorkflows[index].redoCounter = getCurrentUserTotalRedoCount(subscriptionsInfo, "MTL", isAllowedTo('billing.feature')) - baseConfig.version_num + 1;
                setImageWorkflows(newImageWorkflows);
            }

            setCurrentVersion(baseConfig.version)
            setCurrentBaseConfig(baseConfig)
            setGenPipeline(pre => {
                return {
                    ...pre,
                    mtlLoading: {
                        status: true,
                        data: baseConfig,
                        timestamp: Date.now()
                    }
                }
            });
        } catch (error) {
            tip({
                type: 'error',
                presetText: 'ERROR',
                content: error.message,
            });

            if (error.message !== "NO_HISTORY_SETTINGS") {
                Sentry.captureException(error)
            }
        }
    }

    useEffect(() => {
        if (!genPipeline.geoConfirmed.status) return;

        // If history opened, save current stage for reference
        if (historyStatus.showHistoryList && !historyStatus.originalState) {
            let originalConfig = { ...currentBaseConfig, settings: { prompt: inputText } }
            setHistoryStatus({ ...historyStatus, originalState: originalConfig })
        }
        // If history closed without selecting, reset to original state
        if (!historyStatus.showHistoryList && historyStatus.originalState && historyStatus.selectedHistory === false) {
            loadHistory(historyStatus.originalState)
            setHistoryStatus({ ...historyStatus, originalState: false })
            currentViewingHistory.current = false
        }
        // If history selected, load history
        if (historyStatus.selectedHistory) {
            currentViewingHistory.current = historyStatus.selectedHistory
            loadHistory(historyStatus.selectedHistory).then(() => setHistoryStatus({ ...historyStatus, selectedHistory: false, historyList: [], originalState: false }))
            currentViewingHistory.current = false
        }
        // If preview history selected, load history for preview
        if (historyStatus.previewHistory && !historyStatus.selectedHistory && currentViewingHistory.current !== historyStatus.previewHistory) {
            currentViewingHistory.current = historyStatus.previewHistory
            loadHistory(historyStatus.previewHistory).then(() => setHistoryStatus({ ...historyStatus, previewHistory: false }))
        }
    }, [historyStatus]);

    const handleShowCredits = () => {
        if (isImgGenerateState && isAllowedTo('billing.view')) {
            setComfirmBtnInfo(t('BUTTON_SMALL_MATERIAL_GENERATE'))
        }
    }

    const handleCloseCredits = () => {
        if (isImgGenerateState) {
            setComfirmBtnInfo(t('BUTTON_SMALL_MATERIAL_GENERATE'))
        }
    }

    const handleUpload = () => {
        if (!userImage && isCreatorOrAbove() || !isAllowedTo('billing.feature')) {
            document.getElementById('imageUpload').click();
        } else {
            setShowSubTips(true)
            setTimeout(() => {
                setShowSubTips(false)
            }, 5000);
            return
        }
    }

    const handleOpenSub = () => {
        setShowSubscribe(true)
        setShowSubTips(false)
    }

    const handleShowRedo = () => {
        setShowRedoTemp(true)
    }

    const handleShowGenerate = () => {
        if (isImgGenerateState) {
            setShowGenerateTemp(true)
        } else {
            setShowRedoTemp(false)
        }
    }

    const handleCloseTemp = () => {
        setShowRedoTemp(false)
        setShowGenerateTemp(false)
    }

    // const FaceEnableSet = (value) => {
    //     setFaceFlag(true)
    //     const preList = faceCheckList.filter(item => item.id !== selectedImageIndex)
    //     const newObj = {
    //         id: selectedImageIndex,
    //         faceAllow: true,
    //         defaultFace: true,
    //         enable: value
    //     }
    //     const newList = [...preList, newObj]
    //     setFaceCheckList(newList)
    //     setOpenFaceCheck(false)
    // }

    // useEffect(() => {
    //     if (faceFlag) {
    //         handleConfirmOrGenerate()
    //         setFaceFlag(false)
    //     }
    // }, [faceFlag])

    return (
        <div ref={mtlRef} className={`${style.materialWrapper} ${isConfirmed ? style.isConfirmed : ""
            }`}>
            {/*{isLocked && <div className={style.mtlmask} onClick={handlerStop}></div>}*/}
            {/* <div onClick={(e) => {
                if (faceEnablePage.current.contains(e.target)) {
                    return;
                } else {
                    setOpenFaceCheck(false)
                }
            }} className={`fixed  w-[100%] h-[100%] z-[99999] top-0 left-0 flex justify-center items-center ${openFaceCheck ? ' opacity-100 visible' : 'animation-face-check'}`}>
                <div ref={faceEnablePage} className={`p-[24px] max-w-[382px] gap-[12px] font-[Arial] flex flex-col [transition:all_0.3s_cubic-bezier(0.23,1,0.32,1)]  ${openFaceCheck ? ' opacity-100 visible scale-100' : ' opacity-0 invisible scale-0'} bg-[rgba(255,255,255,0.8)] backdrop-blur-[50px] rounded-2xl [box-shadow:0px_0px_12px_0px_rgba(74,0,224,0.15)]`}>
                    <span className='text-[20px] font-bold text-[rgba(45,45,45,1)]'>{t('RODIN_FACE_RESTORE')}</span>
                    {!localStorage.getItem('defaultI18n') || localStorage.getItem('defaultI18n') === 'en' ? <span className='text-[14px] text-[rgba(102,102,102,1)] text-left'>
                        A <strong>face</strong> was detected in your image. We can enhance <strong>facial details</strong>. Enable this feature?
                    </span>
                        : <span className='text-[14px] text-[rgba(102,102,102,1)] text-left'>{t('RODIN_FACE_RESTORE_TITLE')}</span>}
                    <div className='w-full flex flex-row justify-between'>
                        <button onClick={() => { FaceEnableSet(false) }} className='w-[48%] py-[10px] [transition:all_0.3s_ease] bg-[rgba(176,176,176,0.5)] hover:bg-[rgba(176,176,176,0.3)] rounded-[35px] text-[rgba(48,48,48,1)]'>{t('RODIN_FACE_RESTORE_NO')}</button>
                        <button onClick={() => { FaceEnableSet(true) }} className='w-[48%] py-[10px] [transition:all_0.3s_ease] bg-[linear-gradient(180deg,#6D49FF_0%,#A347FF_100%)] hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)] rounded-[35px] text-white'>{t('OPTION_ENABLE')}</button>
                    </div>
                </div>
            </div> */}
            <div className={style.materialHeader}>
                <div className={style.materialTitle}>{t('RODIN_GENERTAE_BOARD_MAT_TITLE')}</div>
                {isLocked ? (
                    <LockTip status={!isLocked} message={t('UNLOCK_GEO_TIP')} />
                ) : (
                    showSubTips ? <div className={`z-[100] flex items-center relative gap-1 w-max text-xs md:text-sm h-full rounded-xl text-[#FF4E4E]`}>
                        <span>Unlock with</span><span onClick={handleOpenSub} className='relative before:absolute before:[content:""] before:left-0 before:bottom-0 before:transition-300-ease before:duration-100 hover:text-[#4a00e0] cursor-pointer before:bg-[#FF4E4E] before:w-full before:h-[1px] hover:before:bg-[#4a00e0]'>subscription</span>
                    </div> :
                        <>
                            {!isDone && !isGenerating && hasHistory() && (
                                <Sentry.ErrorBoundary
                                    fallback={({ error, resetError }) => (
                                        <ErrorPage
                                            errorMessage={error?.message}
                                            resetError={resetError}
                                        />
                                    )}>
                                    <History />
                                </Sentry.ErrorBoundary>
                            )}
                        </>
                )}


            </div>
            <Sentry.ErrorBoundary
                fallback={({ error, resetError }) => (
                    <ErrorPage
                        errorMessage={error?.message}
                        resetError={resetError}
                    />
                )}>
                <div className={`${isLocked || isDone ? style.contentWrapperLocked : style.contentWrapper} ${style.contentW} `}>
                    <div className={style.imagePreviewWrapper}>
                        {
                            getCurrentImageURL() ? (
                                <img src={getCurrentImageURL()} alt="Selected Material"
                                    className={isLocked || isDone ? style.imagePreviewLocked : style.imagePreview} />
                            ) : (
                                <div className={`${style.imagePreview}`}></div>
                            )
                        }
                    </div>
                    <div className={`${style.rightContainer} ${isLocked || isDone || stage === STAGE_ENUM.GENERATING ? 'pointer-events-none':'pointer-events-auto'}`}>
                        <div className={style.materialPromptArea}>
                            <textarea className={style.materialTextArea} placeholder={t('RODIN_GENERTAE_BOARD_MAT_TEXT_AREA')}
                                value={inputText}
                                onChange={handleInputTextChange}></textarea>
                        </div>
                        {!isLocked && !isDone && (
                            <div className={style.uploadAndSelectorContainer}>
                                {/* <XscrollEasy disableScrollingDom={bodyRef.current} > */}
                                <div className={style.uploadWrapper}
                                    onClick={handleUpload}>
                                    <input type="file" id="imageUpload" className={style.hiddenInput}
                                        onChange={handleUserUpload}
                                        disabled={stage === STAGE_ENUM.GENERATING}
                                        accept="image/jpeg, image/jpg, image/png, image/webp" />
                                    {userImage ? (
                                        <div className="relative group">
                                            <img src={userImage}
                                                className={`${style.thumbnail} ${selectedImageIndex === defaultImageURLs.length ? style.selectedThumbnail : ''}`}
                                                alt="User Image" />
                                            {!isGenerating && (
                                                <div
                                                    onClick={(event) => isGenerating ? null : handleUserImageRemove(event)}
                                                    className="absolute top-1 right-1 w-4 items-center justify-center bg-gray-700/50 text-white text-xs rounded-2xl cursor-pointer select-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                    &#215;
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className={style.plusIcon}><LuPlus /></div>
                                    )}
                                </div>
                                <Swiper
                                    modules={[Scrollbar, Mousewheel, FreeMode]}
                                    direction="horizontal"
                                    grabCursor={true}
                                    mousewheel={{
                                        invert: false,
                                        // forceToAxis: true
                                    }}
                                    // scrollbar={{
                                    //   hide: false,
                                    //   draggable: true,
                                    // }}
                                    freeMode={{
                                        enabled: true,
                                        sticky: false,
                                        momentum: true
                                    }}
                                    slidesPerView="auto"
                                    spaceBetween={8}
                                    className={`w-full h-full`}
                                >
                                    <SwiperSlide className="!w-auto !flex !gap-2">
                                        <div className={style.imageSelector}>
                                            {defaultImageURLs && defaultImageURLs.length > 0 ? (
                                                defaultImageURLs.slice().reverse().map((imageUrl, index) => (
                                                    <div key={index}
                                                        className={selectedImageIndex === (defaultImageURLs.length - 1 - index) ? style.selectedThumbnail : style.thumbnail}>
                                                        <img src={imageUrl.data} className={style.thumbnailImg}
                                                            alt={`Choice ${defaultImageURLs.length - index}`}
                                                            onClick={() => handleSelectImage(defaultImageURLs.length - 1 - index)}
                                                        />
                                                    </div>
                                                ))
                                            ) : (
                                                <div></div>
                                            )}
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                                {/* </XscrollEasy> */}
                            </div>
                        )}
                    </div>
                </div>
            </Sentry.ErrorBoundary>
            {(!isLocked && !isDone) && (
                <div className={style.materialFooter}>
                    <div className={style.geometryBtns} onMouseLeave={handleCloseTemp}>
                        {!isGenerating ? (
                            <>
                                {!isImgGenerateState && (
                                    <div onMouseEnter={handleShowRedo} className={`${style.redoBtn}`} onClick={handleRedo}>
                                        {/* {getRedoCounter(selectedImageIndex) <= 2 && (
                                            <div className={style.redoTips}>
                                                <RedoTips />
                                                <div className={style.redoHodler}></div>
                                            </div>
                                        )} */}
                                        <span>{t('BUTTON_REDO')}</span>
                                        <Restricted to="billing.view">
                                            {!historyStatus.showHistoryList && (
                                                <span
                                                    className={style.remaining}>x{getRedoCounter(selectedImageIndex)}</span>
                                            )}
                                        </Restricted>
                                    </div>
                                )}
                                <div id={isImgGenerateState && 'matGenerateTab'} onMouseEnter={handleShowGenerate} className={`${style.confirmBtn} ${isImgGenerateState ? style.credits : style.normal} ${isImgGenerateState ? style.temperature : ''}`}>
                                <span id={!isImgGenerateState && 'matConfirmTab'} className='absolute w-[100%] h-[100%] top-0 left-0 pointer-events-none'></span>
                                    <span className={`${style.confirmSpan}`}

                                        onMouseEnter={handleShowCredits}
                                        onMouseLeave={handleCloseCredits}
                                        onClick={handleConfirmOrGenerate.bind(null, false)}>
                                        {stage === STAGE_ENUM.CHANGED_CONFIRM && (
                                            <ChangeConfirmTip handleRedo={handleRedo} handleConfirmOrGenerate={handleConfirmOrGenerate} currentStage={"MTL"} />
                                        )}
                                        {isImgGenerateState ? confirmBtnInfo : t('BUTTON_SMALL_MATERIAL_CONFIRM')}</span>
                                </div>
                            </>
                        ) : (
                            <WaitingProgress percentage={generatePercentage} queue={isQueued} />
                        )}
                        <Temperature
                            show={showGenerateTemp}
                            sliderValue={sliderValue}
                            setSliderValue={setSliderValue}
                            // selectedImageIndex={selectedImageIndex}
                            // faceCheckList={faceCheckList}
                            // setFaceCheckList={setFaceCheckList}
                        />
                        <Temperature
                            type='redo'
                            show={showRedoTemp}
                            sliderValue={sliderValue}
                            // faceCheckList={faceCheckList}
                            // setFaceCheckList={setFaceCheckList}
                            // selectedImageIndex={selectedImageIndex}
                            setSliderValue={setSliderValue} />
                    </div>
                </div>
            )}
        </div>
    )
};

const Temperature = ({ type, show, sliderValue, setSliderValue }) => {
    //faceCheckList, setFaceCheckList, selectedImageIndex
    const [draging, setDraging] = useState(false);
    // const [Check, setCheck] = useState(false)
    // const [enable, setEnable] = useState(false);
    const { t } = useTranslation();

    // useEffect(() => {
    //     if (faceCheckList.length > 0) {
    //         if (faceCheckList.filter(item => item.id === selectedImageIndex).length > 0) {
    //             if (faceCheckList.filter(item => item.id === selectedImageIndex)[0].faceAllow) {
    //                 setCheck(true)
    //                 setEnable(faceCheckList.filter(item => item.id === selectedImageIndex)[0].enable)
    //             } else {
    //                 setCheck(false)
    //             }
    //         } else {
    //             setCheck(false)
    //         }
    //     }
    // }, [faceCheckList, selectedImageIndex])

    const handleCheckBox = (e) => {
        e.stopPropagation()
        setSliderValue(pre => {
            return {
                ...pre,
                keepSeed: !pre.keepSeed
            }
        })
    }

    const positionStyle = type === 'redo'
        ? { left: 0, transform: `translateY(calc(-100% - 10px))` }
        : { left: '50%', transform: ` translate(-50%, calc(-100% - 10px))` }

    const handleClick = (e) => {
        e.stopPropagation()
    }


    return (
        <div
            className={`${style.temperatureWrapper} ${show ? style.show : ''} ${draging ? style.draging : ""} ${type === 'redo' ? style.redo : style.generate}`}
            style={{ ...positionStyle }} onClick={handleClick}>
            <div className={style.temperatureSlider}>
                <div className={style.temperatureoptions}>
                    <span className={style.options}>{t("RODIN_GENERTAE_BOARD_MAT_OPT")}</span>
                    {type === 'redo' && <label className={style.checkBoxContainer} onClick={handleCheckBox}>
                        <span className={`${style.checkmark} ${sliderValue.keepSeed ? style.checked : ""}`}></span>
                        <span>{t("RODIN_GENERTAE_BOARD_MAT_SEED")}</span>
                    </label>}
                </div>
                <div className={style.temperatureHeader}>
                    <span className='flex items-center gap-[1px] relative'>{t('PBR_TEMPERATURE')}<Annotation text={t('RODIN_GENERTAE_BOARD_MAT_PBRTEMP_EXEG')} bottom={'0.2rem'} left={'-6rem'} /></span>

                </div>

                <Slider
                    name="pbr"
                    value={sliderValue.temperature.currentValue}
                    setValue={setSliderValue}
                    maxRange={10}
                    initialValue={sliderValue.temperature.initialValue}
                    setDraging={setDraging}
                />
                <div className={style.temperatureHeader}>
                    <span className='flex items-center gap-[1px] relative'>{t('REFERENCE_STRENGTH')}<Annotation text={t('RODIN_GENERTAE_BOARD_MAT_REF_EXEG')} bottom={'0.2rem'} left={'-3rem'} /></span>
                </div>

                <Slider
                    name="creativity"
                    value={sliderValue.reference.currentValue}
                    setValue={setSliderValue}
                    maxRange={1}
                    initialValue={sliderValue.reference.initialValue}
                    setDraging={setDraging}
                />

                {/* {Check && <div className='w-full flex flex-row items-center justify-between  '>
                    <span className='h-full mt-[4px] text-[14px] '>Face Restore</span>
                    <div onClick={() => {
                        const newE = !enable
                        setEnable(newE)
                        const preList = faceCheckList.filter(item => item.id !== selectedImageIndex)
                        const newObj = {
                            id: selectedImageIndex,
                            faceAllow: true,
                            defaultFace: faceCheckList.filter(item => item.id === selectedImageIndex)[0]?.defaultFace ? faceCheckList.filter(item => item.id === selectedImageIndex)[0].defaultFace:false,
                            enable: newE
                        }
                        const newList = [...preList, newObj]
                        setFaceCheckList(newList)
                    }} className=' relative flex items-center w-[25%] lg:w-[22%] h-[24px] xs:h-[26px] mt-[10px] rounded-[50px] bg-[rgba(217,217,217,1)] [border:1.5px_solid_rgba(238,238,238,1)] cursor-pointer'>
                        <div className={`absolute z-[1] h-[85%] text-[11px] leading-[10px] w-[70%] rounded-[50px] flex justify-center items-center   [transition:all_0.2s_ease] font-bold left-[2%] ${enable ? 'translate-x-0 bg-[rgba(230,224,249,1)] text-[rgba(74,0,224,1)] [border:1px_solid_rgba(74,0,224,1)]' : 'translate-x-[38%] bg-[rgba(238,238,238,1)] text-[rgba(119,119,119,1)] [border:1px_solid_rgba(153,153,153,1)]'}`}>{enable ? 'ON' : 'OFF'}</div>
                    </div>
                </div>} */}
            </div>
            <div className={style.bottomHodler}></div>
        </div>
    );
};

const Slider = React.memo(({ name, value, setValue, maxRange, setDraging, initialValue }) => {
    const [position, setPosition] = useState(value);
    const rangeRef = useRef(null);
    const knobRef = useRef(null);

    useEffect(() => {
        if (rangeRef.current && knobRef.current) {
            setPosition(initialValue / maxRange * (rangeRef.current.clientWidth - knobRef.current.clientWidth))
        }
    }, [rangeRef, knobRef, initialValue]);

    function roundToNearestHalf(number, precision = 1) {
        const factor = Math.pow(10, precision);
        return Math.round(number * 2 * factor) / (2 * factor);
    }

    const handleClickPosition = (e) => {
        setDraging && setDraging(true)
        const rangedom = rangeRef.current
        const knobdom = knobRef.current
        const totalWidth = rangedom.clientWidth - knobdom.clientWidth
        const left = rangedom.getBoundingClientRect().left
        const startX = e.clientX;
        let diffX = startX - left
        if (diffX <= 0) {
            diffX = 0
        }
        if (diffX >= (rangedom.clientWidth - knobdom.clientWidth)) {
            diffX = (rangedom.clientWidth - knobdom.clientWidth)
        }
        setPosition(diffX)
        const v = roundToNearestHalf(diffX / totalWidth * maxRange, name === 'pbr' ? 0 : 1)
        setValue(pre => {
            const key = name === 'pbr' ? 'temperature' : 'reference';
            return {
                ...pre,
                [key]: {
                    ...pre[key],
                    currentValue: v,
                    initialValue: v
                }
            };
        });
        document.onmousemove = (e) => {
            setDraging && setDraging(true)
            e.stopPropagation()
            const endX = e.clientX;
            let diffX = startX - left + endX - startX
            if (diffX <= 0) {
                diffX = 0
            }
            if (diffX >= (rangedom.clientWidth - knobdom.clientWidth)) {
                diffX = (rangedom.clientWidth - knobdom.clientWidth)
            }
            setPosition(diffX)
            const v = roundToNearestHalf(diffX / totalWidth * maxRange, name === 'pbr' ? 0 : 1)
            setValue(pre => {
                const key = name === 'pbr' ? 'temperature' : 'reference';
                return {
                    ...pre,
                    [key]: {
                        ...pre[key],
                        currentValue: v,
                        initialValue: v
                    }
                };
            });
        }
        document.onmouseup = function () {
            setDraging && setDraging(false)
            e.stopPropagation()
            document.onmousemove = null;
            document.onmouseup = null;
        };
    }

    const handleStart = (operate, e) => {
        e.stopPropagation()
        setDraging && setDraging(true)
        if (operate === 'mouse' && e.button !== 0) return;
        if (operate === 'touch' && e.touches.length !== 1) return;
        if (e.button !== 0) return

        const rangedom = rangeRef.current
        const knobdom = knobRef.current
        const totalWidth = rangedom.clientWidth - knobdom.clientWidth
        const startX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
        const selfXPosition = knobdom.offsetLeft
        const handleMove = (e) => {
            setDraging && setDraging(true)
            e.stopPropagation()
            const endX = operate === 'mouse' ? e.clientX : e.touches[0].clientX;
            let diffX = selfXPosition + endX - startX
            if (diffX <= 0) {
                diffX = 0
            }
            if (diffX >= (rangedom.clientWidth - knobdom.clientWidth)) {
                diffX = (rangedom.clientWidth - knobdom.clientWidth)
            }

            setPosition(diffX)
            const v = roundToNearestHalf(diffX / totalWidth * maxRange, name === 'pbr' ? 0 : 1)
            setValue(pre => {
                const key = name === 'pbr' ? 'temperature' : 'reference';
                return {
                    ...pre,
                    [key]: {
                        ...pre[key],
                        currentValue: v,
                        initialValue: v
                    }
                };
            });
        }
        const handleEnd = () => {
            setDraging && setDraging(false)
            if (operate === 'mouse') {
                document.removeEventListener('mousemove', handleMove);
                document.removeEventListener('mouseup', handleEnd);
            } else {
                document.removeEventListener('touchmove', handleMove);
                document.removeEventListener('touchend', handleEnd);
                document.removeEventListener('touchcancel', handleEnd);
            }
        }
        if (operate === 'mouse') {
            document.addEventListener('mousemove', handleMove);
            document.addEventListener('mouseup', handleEnd);
        } else {
            document.addEventListener('touchmove', handleMove);
            document.addEventListener('touchend', handleEnd);
            document.addEventListener('touchcancel', handleEnd);
        }
    }
    return (
        <div className={style.sliderContainer}>
            <div className={style.slidertrack} onPointerDown={handleClickPosition} ref={rangeRef}>
                <div className={style.sliderInner}>
                    {[...Array(40 + 1)].map((_, index) => (
                        <div
                            style={{
                                left: `${index * 2.5}%`,
                                display: `${index % 2 === 0 ? 'none' : 'block'}`
                            }}
                            key={index}
                            className={style.sliderstep}></div>
                    ))}
                    <div
                        className={style.sliderthumb} ref={knobRef}
                        style={{ left: `${position}px` }}
                        onMouseDown={handleStart.bind(null, 'mouse')}
                        onTouchStart={handleStart.bind(null, 'touch')}
                    ></div>
                    <div className={style.rangeBg} style={{
                        width: `${position}px`,
                    }}></div>
                </div>
            </div>
            <div className={style.rangeVal}>{value}</div>
        </div>
    );
})

Slider.displayName = 'Slider';
export default MaterialGeneration
